export default __webpack_public_path__ + "static/Tangle5-dd9d1da6be2c1d404c929df447b45542.jpg";